import './live_qa_card.css';
